<template>
    <div class="getfree">
        <div class="header">
            <div></div>
            <span>主商品</span>
        </div>
        <div class="main">
            <div class="main-left">
                <div>
                    <goodsImage @click="goSku" :goods="goods" :imageSize="185"></goodsImage>
                    <div>
                        <goodsGroupLabel :goods="goods"></goodsGroupLabel>
                    </div>
                </div>
            </div>
            <div class="main-right">
                <div>
                    <goodsLabel :goods="goods" width="400"></goodsLabel>
                    <p>{{ goods.goods_name }}</p>
                </div>
                <goodsPrice size="24px" :info="goods"></goodsPrice>
                <ctrlShowText :info="goods" type="custom"  size="16px"  gap="6px" color="#A2A1A1"></ctrlShowText>
                <div class="footer">
                    <shareCounter ref="shareCounter" :number="goods.min_buy" :goodsSkuDetail="{
                        min_buy: goods.min_buy,
                        stock: goods.goods_stock,
                        package_num: goods.package_num || goods.min_buy,
                        is_member_by: goods.sale_control?.is_member_by,
                        view_price: goods.sale_control?.view_price,
                        sale_control_name: goods.sale_control?.sale_control_name
                    }" size="mini" @upnumber="upnumber"></shareCounter>
                    <template v-if="$store.getters.token">
                        <div class="addrad"
                            :class="goods.sale_control && goods.sale_control?.view_price ? 'addrad' : 'ban'"
                            @click="joinCart(goods)">加入购物车</div>
                    </template>
                    <template v-else>
                        <div class="addrad" @click="joinCart(goods)">加入购物车</div>
                    </template>
                </div>
            </div>
        </div>
        <div class="sub-header">
            <div></div>
            <span>副商品</span>
            <p>（可换品种<span>{{ (goods.get_free_goods&&parseFloat(goods.get_free_goods.goods_range)>0)?(goods.get_free_goods.goods_range):'不限' }}</span>种）</p>
        </div>
        <div class="sub-goods overflowBar">
            <template v-for="(exitem, index) in goods.get_free_goods?.getFreeGoods || []" >
                <div class="sub-goods-item">
                    <div class="main-left">
                        <div>
                            <goodsImage @click="goSku" :goods="exitem" :imageSize="135"></goodsImage>
                            <div>
                                <goodsGroupLabel :goods="exitem"></goodsGroupLabel>
                            </div>
                        </div>
                    </div>
                    <div class="main-right">
                        <div>
                            <goodsLabel :goods="exitem" width="400"></goodsLabel>
                            <p>{{ exitem.goods.goods_name }}</p>
                        </div>
                        <goodsPrice size="24px" :info="exitem"></goodsPrice>
                        <ctrlShowText :info="exitem" type="custom"  size="16px"  gap="6px" color="#A2A1A1"></ctrlShowText>
                    </div>
                </div>
            </template>
            <template v-if="goods.get_free_goods?.getFreeGoods.length === 0">
                <div class="empty-box">
                    <el-empty description="暂无副商品"></el-empty>
                </div>
            </template>
        </div>
        <template v-if="goods.get_free_goods?.getFreeGoods.length > 0">
            <div class="sub-goods-tip">
                <template v-for="(exitem, index) in goods.get_free_goods?.getFreeGoods || []" >
                    <template v-if="index < 2">
                        <div class="get_free_goods_text">
                            <p>{{ exitem.goods.goods_name }}</p>
                            <p>{{ returnFreeText(exitem) }}</p>
                        </div>
                    </template>
                </template>
                <template v-if="goods.get_free_goods?.getFreeGoods.length > 1">
                    <div class="moreTip" @click="showMoreDialog">
                        <span>更多</span>
                        <span class="el-icon-arrow-down"></span>
                    </div>
                </template>
            </div>
        </template>

        <!-- 添加弹窗组件 -->
         <!-- 弹窗基于屏幕居中 -->
        <el-dialog title="活动详情" :visible.sync="dialogVisible" width="50%" z-index="10" :append-to-body="true">
            <div class="sub-goods-tip" style="padding: 0;display: flex;flex-direction: column;box-sizing: border-box;">
                <template v-for="(exitem, index) in goods.get_free_goods?.getFreeGoods || []" >
                    <div class="get_free_goods_text" style="display: flex;flex-direction: column;overflow: hidden;">
                        <p style="font-weight: 400;font-size: 16px;color: #828181;line-height: 22px;">{{ exitem.goods.goods_name }}</p>
                        <p style="font-weight: 400;font-size: 16px;color: #1EB43C;line-height: 22px;">{{ returnFreeText(exitem) }}</p>
                    </div>
                </template>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import shareCounter from "@/components/shareCounter.vue"
import { onTip } from "@/utils/tips"
import ctrlShowText from "@/components/ctrl-show-text/ctrl-show-text.vue";
import goodsPrice from '@/components/goods-price/goods-price.vue'
import goodsLabel from "@/components/goods-label/goods-label.vue";
import goodsCodeLabel from "@/components/goods-label/goods-code-label.vue";
import goodsGroupLabel from "@/components/goods-label/goods-group-label.vue";
import goodsImage from "@/components/goods-image/goods-image.vue";
export default {
    components: {
        shareCounter,ctrlShowText,goodsPrice,goodsLabel,goodsCodeLabel,goodsGroupLabel,goodsImage
    },
    props: {
        goods: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            isScrolling: false,
            startX: 0,
            scrollLeft: 0,
            datainfo: [1, 2, 3, 4],
            number: 1,
            dialogVisible: false, // 添加弹窗显示控制变量
        }
    },
    computed: {
        ...mapGetters(["defaultGoodsImage", "storeWithoutAuthority"]),
    },
    mounted(){
        
    },
    methods: {
        returnFreeText(item){
            let bool = (this.goods.get_free_goods.is_ladder>0)
            if(bool){
                if(typeof item.ladder_json === 'string'){
                    item.ladder_json = JSON.parse(item.ladder_json)
                }
                let arr = [];
                item.ladder_json.forEach((item1,index)=>{
                    arr.push(`主商品x${item1.mainRang}可换${item1.rang}${item.goods.unit}每${item.goods.unit}￥${item1.rangPrice}`)
                })
                let str = arr.join('；')
                return str;
            }else{
                if(item.limit>0){
                    return `主商品x${item.count}可换${ item.num }${ item.goods.unit?item.goods.unit:'个' }每${item.goods.unit?item.goods.unit:'个'}￥${item.price}`;
                }else{
                    return `主商品x${item.count}可换${ item.num }${ item.goods.unit?item.goods.unit:'个' }每${item.goods.unit?item.goods.unit:'个'}￥${item.price},换购数量无上限`;
                }
            }
        },
        showFreePrice(info){
            if(!info||!info.sale_control){
                return "";
            }
            if(info.sale_control.is_member_by&&info.sale_control.view_price){
                let price = info.price;
                console.log("数据---",info);
                if (this.goods.get_free_goods.is_ladder > 0) {
                    price = info.goods.price;
                    if(typeof info.ladder_json === 'string'){
                        info.ladder_json = JSON.parse(info.ladder_json)
                    }
                    let num = this.number;
                    info.ladder_json.forEach((item1,index)=>{
                        if(num>=parseFloat(item1.mainRang)){
                            price = parseFloat(item1.rangPrice);
                            // if(info.limit===0){
                            //     price = parseFloat(item1.rangPrice);
                            // }else{
                            //     if(info.limit>=parseFloat(item1.mainRang)){
                            //         price = parseFloat(item1.rangPrice);
                            //     }
                            // }
                        }
                    })
                }
                return price
            }else{
                return info.sale_control.not_buy_msg
            }
        },
        /**
         * 图片加载失败
         */
        imageError(index) {
            this.goods.get_free_goods.getFreeGoods[index].goods.goods_image = this.defaultGoodsImage
        },
        // 加入购物车
        joinCart(item) {
            if (onTip(item.sale_control?.view_price, item.sale_control?.is_member_by, this, item.sale_control?.not_buy_msg)) return
            if (!this.goods.get_free_goods?.getFreeGoods.length > 0) {
                this.$message({
                    message: "暂无副商品",
                    type: "error"
                })
                return
            }
            this.$store
                .dispatch("cart/add_to_cart", {
                    site_id: item.site_id,
                    sku_id: item.sku_id,
                    num: this.number
                })
                .then((res) => {
                    if (res.code === 0) {
                        this.$message({
                            message: "加入购物车成功",
                            type: "success"
                        })
                    }
                })
                .catch((err) => {
                    if (err.message === "token不存在") {
                        this.$router.pushToTab("/login")
                    } else {
                        this.$message.error(err.message);
                        if(typeof err.data === 'number'){
                            if(err.data > 0){
                                this.$refs.shareCounter.upnumber(err.data);
                                this.$message({
                                    message: "当前数量已更改为可购买数量，请重试加入购物车",
                                    type: "success"
                                });
                            }else{
                                window.location.reload();
                            }
                        }
                    }
                })
        },
        goSku(item) {
            if (!this.$store.getters.token) {
                this.$router.pushToTab("/login")
                return
            }
            if (onTip(item.sale_control.view_price, item.sale_control.is_member_by, this, item.sale_control.not_buy_msg)) return
            this.$router.pushToTab("/sku-" + (item.sku_id||item.goods.sku_id))
        },
        upnumber(val) {
            this.number = val
        },
        startScroll(e) {
            this.isScrolling = true
            this.startX = e.pageX - this.$refs.container.offsetLeft
            this.scrollLeft = this.$refs.container.scrollLeft
        },
        stopScroll() {
            this.isScrolling = false
        },
        onScroll(e) {
            if (!this.isScrolling) return
            e.preventDefault()
            const x = e.pageX - this.$refs.container.offsetLeft
            const walk = (x - this.startX) * 2 // 滚动速度
            this.$refs.container.scrollLeft = this.scrollLeft - walk
        },
        showMoreDialog() {
            console.log("showMoreDialog",this.dialogVisible);
            this.dialogVisible = true;
        }
    }
}
</script>

<style lang="scss" scoped>
.getfree {
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, rgba(50, 188, 111, 0.3) 0%, #FFFFFF 20%,#FFFFFF 100%);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    .header{
        width: 100%;
        display: flex;
        align-items: center;
        padding-top: 14px;
        gap: 9px;
        >div{
            width: 3px;
            height: 21px;
            background-color: #32BC6F;
        }
        >span{
            font-weight: bold;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 28px;
        }
    }
    .sub-header{
        width: 100%;
        display: flex;
        align-items: center;
        gap: 9px;
        >div{
            width: 3px;
            height: 21px;
            background-color: #32BC6F;
        }
        >span{
            font-weight: bold;
            font-size: 20px;
            color: #3D3D3D;
            line-height: 28px;
        }
        p{
            font-size: 20px;
            color: #979797;
            line-height: 28px;
            span{
                color: #32BC6F;
                font-size: 26px;
                margin: 0 6px;
            }
        }
    }
    .main{
        display: flex;
        >div:nth-child(1){
            width: 50%;
        }
        >div:nth-child(2){
            width: 50%;
        }
        .main-left{
            display: flex;
            align-items: center;
            justify-content: center;
            >div{
                display: flex;
                flex-direction: column;
                gap: 12px;
                >img{
                    height: 185px;
                    box-sizing: border-box;
                    object-fit: contain;
                }
            }
        }
        .main-right{
            display: flex;
            flex-direction: column;
            gap: 12px;
            >div:nth-child(1){
                display: flex;
                align-items: flex-start;
                overflow: hidden;
                gap: 6px;
                position: relative;
                >div{
                    position: absolute;
                    top: 4px;
                }
                p{
                    font-size: 20px;
                    color: #3D3D3D;
                    line-height: 28px;
                    text-indent: 2em;
                    // 两行文本溢出显示...
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-all;
                    white-space: normal;
                }
            }
            .footer{
                display: flex;
                align-items: center;
                gap: 12px;
            }
        }
    }
    .addrad {
        cursor: pointer;
        padding: 3px 18px;
        border-radius: 40px;
        background: #32BC6F;
        color: #fff;
    }

    .ban {
        cursor: not-allowed;
        padding: 3px 18px;
        border-radius: 40px;
        background: #dddddd6e;
        color: $base-color-whtie;
    }
    .overflowBar{
        scrollbar-width: thin;
        scrollbar-color: #1EB43C #f5f5f5;
        &::-webkit-scrollbar{
            width: 5px;
        }
        &::-webkit-scrollbar-thumb{
            background-color: #1EB43C;
            border-radius: 5px;
        }
        &::-webkit-scrollbar-track{
            background-color: #f5f5f5;
            border-radius: 5px;
        }
    }
    .sub-goods{
        flex: 1;
        display: flex;
        align-items: stretch;
        overflow: auto;
        padding:12px 0;
        box-sizing: border-box;
        gap: 12px;
        margin: 0 12px;

        .sub-goods-item{
            width: 75%;
            display: flex;
            align-items: flex-start;
            overflow: hidden;
            gap: 12px;
            flex-shrink: 0;

            .main-left{
                display: flex;
                align-items: center;
                justify-content: center;
                >div{
                    display: flex;
                    flex-direction: column;
                    gap: 12px;
                    >img{
                        height: 135px;
                        box-sizing: border-box;
                        object-fit: contain;
                    }
                }
            }
            .main-right{
                display: flex;
                flex-direction: column;
                gap: 12px;
                width: calc(100% - 192px - 12px);
                overflow: hidden;
                >div:nth-child(1){
                    display: flex;
                    align-items: baseline;
                    overflow: hidden;
                    gap: 6px;
                    p{
                        font-size: 20px;
                        color: #3D3D3D;
                        line-height: 28px;
                        // 两行文本溢出显示...
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        word-break: break-all;
                        white-space: normal;
                    }
                }
                .footer{
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }
            }
        }
        .empty-box{
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    .sub-goods-tip{
        display: flex;
        flex-direction: column;
        padding: 12px;
        box-sizing: border-box;
        position: relative;

        .get_free_goods_text{
            display: flex;
            flex-direction: column;
            max-width: 90%;
            overflow: hidden;
            p:nth-child(1){
                font-weight: 400;
                font-size: 16px;
                color: #828181;
                line-height: 22px;
            }
            p:nth-child(2){
                font-weight: 400;
                font-size: 16px;
                color: #1EB43C;
                line-height: 22px;
            }
        }
        .moreTip{
            position: absolute;
            right: 12px;
            bottom: 12px;
            cursor: pointer;
            display: flex;
            align-items: center;
            span{
                font-weight: 400;
                font-size: 16px;
                color: #3D3D3D;
                line-height: 22px;
            }
            span:nth-child(2){
                color: #32BC6F;
            }  
        }
    }
}

</style>
